import { action } from 'nanostores'

import { $deliveryZones, $promises, $zipDeliveryZoneIds } from './stores'

export const setDeliveryZone = action(
  $deliveryZones,
  'setDeliveryZone',
  (store, { deliveryZoneId, deliveryZone }) => {
    store.setKey(String(deliveryZoneId), deliveryZone)
  },
)
export const setZipDeliveryZoneId = action(
  $zipDeliveryZoneIds,
  'setZipDeliveryZoneId',
  (store, { zip, deliveryZoneId }) => {
    store.setKey(zip, deliveryZoneId)
  },
)
export const setPromise = action(
  $promises,
  'setPromise',
  (store, { promiseKey, promise }) => {
    store.setKey(promiseKey, promise)
  },
)
export const clearPromises = action($promises, 'clearPromises', (store) => {
  store.set({})
})
